import {
  arrayCopytctsywo3h7gj as arrayCopy,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  VOID3gxj6tk5isa35 as VOID,
  toShort36kaw0zjdq3ex as toShort,
  fill3lmv1pckd4inv as fill,
  toByte4i43936u611k as toByte,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  protoOf180f3jzyo7rfj as protoOf,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  equalsLong28bsrfhwvd686 as equalsLong,
  shiftLeft1ck77p6vapyra as shiftLeft,
  bitwiseOr1ita6dahwp8zb as bitwiseOr,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  charArray2ujmm1qusno00 as charArray,
  numberToChar93r9buh19yek as numberToChar,
  fromInt1lka3ktyu79a4 as fromInt,
  Long2qws0ah9gnpki as Long,
  bitwiseAnd2g7wmsfd45l12 as bitwiseAnd,
  println2shhhgwwt4c61 as println,
  add85si75olwt6n as add,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  numberToLong345n6tb1n1i71 as numberToLong,
  toNumberlmbpvqo27r53 as toNumber,
  roundToInt1ue8x8yshtznx as roundToInt,
  createThis2j2avj17cvnv2 as createThis,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
class UByteArrayInt {
  constructor(data) {
    this.ab2_1 = data;
  }
  toString() {
    return UByteArrayInt__toString_impl_f8qdsi(this.ab2_1);
  }
  hashCode() {
    return UByteArrayInt__hashCode_impl_y17rdr(this.ab2_1);
  }
  equals(other) {
    return UByteArrayInt__equals_impl_xlvwxn(this.ab2_1, other);
  }
}
class Companion {
  constructor() {
    this.mb2_1 = 2;
  }
}
class TypedBuffer {}
function get_size() {
  return this.f72().jb2() / this.qb2() | 0;
}
class Uint16Buffer {
  constructor(buffer) {
    this.pb2_1 = buffer;
  }
  f72() {
    return _Uint16Buffer___get_buffer__impl__rei8ax(this.pb2_1);
  }
  qb2() {
    return _Uint16Buffer___get_elementSizeInBytes__impl__tcik7m(this.pb2_1);
  }
  toString() {
    return Uint16Buffer__toString_impl_rxffha(this.pb2_1);
  }
  hashCode() {
    return Uint16Buffer__hashCode_impl_lcipoz(this.pb2_1);
  }
  equals(other) {
    return Uint16Buffer__equals_impl_u4cl2n(this.pb2_1, other);
  }
}
class SimpleBytesDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.hb3_1 = initialBits;
    this.ib3_1 = allowGrow;
    this.jb3_1 = new SimpleRingBuffer(this.hb3_1);
    this.kb3_1 = new Int8Array(1024);
    this.lb3_1 = new Long(0, 0);
    this.mb3_1 = new Long(0, 0);
  }
  za0() {
    return this.jb3_1.gb3_1;
  }
  aa1(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.jb3_1.aa1(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.lb3_1;
      tmp.lb3_1 = add(this_0, fromInt(out));
    }
    return out;
  }
  ob3(buffer, offset, size) {
    var out = this.jb3_1.ob3(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.mb3_1;
      tmp.mb3_1 = add(this_0, fromInt(out));
    }
    return out;
  }
  hashCode() {
    return this.jb3_1.ea1();
  }
  equals(other) {
    var tmp;
    if (other instanceof SimpleBytesDeque) {
      tmp = this.jb3_1.equals(other.jb3_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class SimpleChunkedByteDeque {
  constructor() {
    this.pb3_1 = ArrayDeque.ul();
    this.qb3_1 = 0;
    this.rb3_1 = 0;
  }
  p73(data, offset, size) {
    writeFullNoCopy(this, copyOfRange(data, offset, offset + size | 0));
  }
  ob3(data, offset, size) {
    if (offset < 0 || (offset + size | 0) > data.length)
      throw IndexOutOfBoundsException.ve();
    var coffset = offset;
    var pending = size;
    var readTotal = 0;
    $l$loop_0: while (pending > 0) {
      // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.pb3_1.n1()) {
        tmp = this.pb3_1.vl();
      } else {
        tmp = null;
      }
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var chunk = tmp_0;
      var availableInChunk = chunk.length - this.qb3_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = pending;
      var toCopy = Math.min(availableInChunk, b);
      if (toCopy <= 0)
        break $l$loop_0;
      arraycopy_9(chunk, this.qb3_1, data, coffset, toCopy);
      coffset = coffset + toCopy | 0;
      pending = pending - toCopy | 0;
      readTotal = readTotal + toCopy | 0;
      consumeChunkSize(this, chunk, toCopy);
    }
    return readTotal;
  }
}
class SimpleRingBuffer {
  constructor(bits) {
    this.zb2_1 = bits;
    this.ab3_1 = 1 << this.zb2_1;
    this.bb3_1 = this.ab3_1 - 1 | 0;
    this.cb3_1 = new Int8Array(this.ab3_1);
    this.db3_1 = 0;
    this.eb3_1 = 0;
    this.fb3_1 = this.ab3_1;
    this.gb3_1 = 0;
  }
  sa9() {
    return this.cb3_1;
  }
  ta9() {
    return this.db3_1 & this.bb3_1;
  }
  ua9() {
    return this.eb3_1 & this.bb3_1;
  }
  va9(count) {
    if (count < 0 || count > this.fb3_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.o(toString(message));
    }
    this.eb3_1 = this.eb3_1 + count | 0;
    this.gb3_1 = this.gb3_1 + count | 0;
    this.fb3_1 = this.fb3_1 - count | 0;
  }
  wa9(count) {
    if (count < 0 || count > this.gb3_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.o(toString(message));
    }
    this.db3_1 = this.db3_1 + count | 0;
    this.gb3_1 = this.gb3_1 - count | 0;
    this.fb3_1 = this.fb3_1 + count | 0;
  }
  xa9() {
    var tmp0 = this.gb3_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.ab3_1 - (this.db3_1 & this.bb3_1) | 0;
    return Math.min(tmp0, b);
  }
  ya9() {
    var tmp0 = this.fb3_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.ab3_1 - (this.eb3_1 & this.bb3_1) | 0;
    return Math.min(tmp0, b);
  }
  nb3(consume) {
    while (consume.gb3_1 > 0) {
      var tmp0 = consume.xa9();
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.ya9();
      var copySize = Math.min(tmp0, b);
      arraycopy_9(consume.sa9(), consume.ta9(), this.sa9(), this.ua9(), copySize);
      consume.wa9(copySize);
      this.va9(copySize);
    }
  }
  aa1(data, offset, size) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.fb3_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      var tmp0 = remaining;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.ya9();
      var chunkSize = Math.min(tmp0, b);
      if (chunkSize <= 0)
        break $l$loop;
      arraycopy_9(data, coffset, this.cb3_1, this.ua9(), chunkSize);
      this.va9(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  ob3(data, offset, size) {
    return this.ca1(this.da1(data, offset, size));
  }
  ca1(size) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.gb3_1;
    var toRead = Math.min(a, size);
    this.db3_1 = (this.db3_1 + toRead | 0) & this.bb3_1;
    this.fb3_1 = this.fb3_1 + toRead | 0;
    this.gb3_1 = this.gb3_1 - toRead | 0;
    return toRead;
  }
  da1(data, offset, size) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.gb3_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.cb3_1;
    var mask = this.bb3_1;
    var coffset = offset;
    var lReadPos = this.db3_1;
    $l$loop: while (true) {
      var tmp0 = toRead;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.xa9();
      var toReadChunk = Math.min(tmp0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      arraycopy_9(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  j72() {
    if (this.gb3_1 <= 0)
      return -1;
    var out = this.cb3_1[this.db3_1] & 255;
    this.db3_1 = (this.db3_1 + 1 | 0) & this.bb3_1;
    this.gb3_1 = this.gb3_1 - 1 | 0;
    this.fb3_1 = this.fb3_1 + 1 | 0;
    return out;
  }
  za9(offset) {
    return this.cb3_1[(this.db3_1 + offset | 0) & this.bb3_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof SimpleRingBuffer) {
      tmp_0 = this.gb3_1 === other.gb3_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp2 = this.gb3_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.memory.SimpleRingBuffer.equaler' call
        var inductionVariable = 0;
        if (inductionVariable < tmp2)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.za9(n) === other.za9(n))) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp2);
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.ea1();
  }
  ea1() {
    // Inline function 'korlibs.memory.SimpleRingBuffer.hashCoder' call
    var count = this.gb3_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        out = tmp + this.za9(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.sb3_1 = _ByteUnits___init__impl__x795am(0.0);
  }
  tb3(bytes) {
    return _ByteUnits___init__impl__x795am(bytes);
  }
  ub3(bytes) {
    return _ByteUnits___init__impl__x795am(toNumber(bytes));
  }
}
class Companion_1 {
  yb1(src, srcPosBytes, dst, dstPosBytes, sizeInBytes) {
    dst.vb3(dstPosBytes, sizeInBytes).set(src.vb3(srcPosBytes, sizeInBytes), 0);
  }
  zb1(src, srcPosBytes, dst, dstPosBytes, sizeInBytes) {
    return equalsCommon_0(this, src, srcPosBytes, dst, dstPosBytes, sizeInBytes, false);
  }
}
class Buffer {
  constructor(dataView) {
    return new.target.wb3(dataView);
  }
  static wb3(dataView) {
    var $this = createThis(this);
    $this.cb2_1 = dataView;
    return $this;
  }
  static eb2(size, direct) {
    direct = direct === VOID ? false : direct;
    return this.wb3(new DataView(new ArrayBuffer(checkNBufferSize(size))));
  }
  xb3() {
    return this.cb2_1.byteOffset;
  }
  jb2() {
    return this.cb2_1.byteLength;
  }
  rb2(start, end) {
    return Buffer.wb3(new DataView(get_buffer(this), this.xb3() + start | 0, end - start | 0));
  }
  vb3(offset, size) {
    return new Uint8Array(get_buffer(this), this.cb2_1.byteOffset + offset | 0, size);
  }
  db2(bufferOffset, array, arrayOffset, len, toArray) {
    var bufferSlice = new Int8Array(this.cb2_1.buffer, this.cb2_1.byteOffset + bufferOffset | 0, len);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var arraySlice = array.subarray(arrayOffset, arrayOffset + len | 0);
    if (toArray) {
      arraySlice.set(bufferSlice, 0);
    } else {
      bufferSlice.set(arraySlice, 0);
    }
  }
  xb2(byteOffset) {
    return this.cb2_1.getInt8(byteOffset);
  }
  vb2(byteOffset) {
    return this.cb2_1.getInt16(byteOffset, true);
  }
  lb2(byteOffset) {
    return this.cb2_1.getInt32(byteOffset, true);
  }
  yb2(byteOffset) {
    var v0 = bitwiseAnd(fromInt(this.lb2(byteOffset)), new Long(-1, 0));
    var v1 = bitwiseAnd(fromInt(this.lb2(byteOffset + 4 | 0)), new Long(-1, 0));
    return get_isLittleEndian() ? bitwiseOr(shiftLeft(v1, 32), v0) : bitwiseOr(shiftLeft(v0, 32), v1);
  }
  gb2(byteOffset) {
    return this.cb2_1.getFloat32(byteOffset, true);
  }
  wb2(byteOffset) {
    return this.cb2_1.getInt16(byteOffset, false);
  }
  tb2(byteOffset) {
    return this.cb2_1.getInt32(byteOffset, false);
  }
  fb2(byteOffset) {
    return this.cb2_1.getFloat32(byteOffset, false);
  }
  sb2(byteOffset, value) {
    return this.cb2_1.setInt8(byteOffset, value);
  }
  ob2(byteOffset, value) {
    return this.cb2_1.setInt16(byteOffset, value, true);
  }
  kb2(byteOffset, value) {
    return this.cb2_1.setInt32(byteOffset, value, true);
  }
  ib2(byteOffset, value) {
    return this.cb2_1.setFloat32(byteOffset, value, true);
  }
  nb2(byteOffset, value) {
    return this.cb2_1.setInt16(byteOffset, value, false);
  }
  ub2(byteOffset, value) {
    return this.cb2_1.setInt32(byteOffset, value, false);
  }
  hb2(byteOffset, value) {
    return this.cb2_1.setFloat32(byteOffset, value, false);
  }
  hashCode() {
    return hashCodeCommon(Companion_instance_1, this);
  }
  f7() {
  }
  equals(other) {
    return equalsCommon(Companion_instance_1, this, other);
  }
  toString() {
    return NBuffer_toString(this);
  }
}
//endregion
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_0(src, srcPos, dst, dstPos, size) {
  Companion_instance_1.yb1(src, srcPos, dst, dstPos, size);
}
function arrayfill(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? get_size_0(array) : end;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      setUInt8(array, n, value);
    }
     while (inductionVariable < end);
}
function arrayequal(src, srcPos, dst, dstPos, size) {
  return Companion_instance_1.zb1(src, srcPos, dst, dstPos, size);
}
function arraycopy_1(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_2(src, srcPos, dst, dstPos, size) {
  Uint16Buffer__setArray_impl_x4uzt(dst, dstPos, src, srcPos, size);
}
function _UShortArrayInt___init__impl__kdofb8(data) {
  return data;
}
function _UShortArrayInt___get_data__impl__l4stnv($this) {
  return $this;
}
function _UShortArrayInt___init__impl__kdofb8_0(size) {
  return _UShortArrayInt___init__impl__kdofb8(new Int16Array(size));
}
function UShortArrayInt__get_impl_ciz20k($this, index) {
  return _UShortArrayInt___get_data__impl__l4stnv($this)[index] & 65535;
}
function UShortArrayInt__set_impl_38wgvc($this, index, value) {
  _UShortArrayInt___get_data__impl__l4stnv($this)[index] = toShort(value);
}
function asUShortArrayInt(_this__u8e3s4) {
  return _UShortArrayInt___init__impl__kdofb8(_this__u8e3s4);
}
function arrayadd(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? (new Uint16Buffer(array)).s2() : end;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      Uint16Buffer__set_impl_g0kliu(array, n, Uint16Buffer__get_impl_6qi0dm(array, n) + value | 0);
    }
     while (inductionVariable < end);
}
function arraycopy_3(src, srcPos, dst, dstPos, size) {
  return arraycopy_0(_Int32Buffer___get_buffer__impl__dnrimm(src), imul(srcPos, 4), _Int32Buffer___get_buffer__impl__dnrimm(dst), imul(dstPos, 4), imul(size, 4));
}
function arrayfill_0(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? array.length : end;
  return fill(array, value, start, end);
}
function arraycopy_4(src, srcPos, dst, dstPos, size) {
  Int8Buffer__setArray_impl_oimleb(dst, dstPos, src, srcPos, size);
}
function arraycopy_5(src, srcPos, dst, dstPos, size) {
  Float32Buffer__setArray_impl_eosj51(dst, dstPos, src, srcPos, size);
}
function arraycopy_6(src, srcPos, dst, dstPos, size) {
  Int32Buffer__setArray_impl_eeeiw8(dst, dstPos, src, srcPos, size);
}
function _UByteArrayInt___init__impl__xif7bu(data) {
  return data;
}
function _UByteArrayInt___get_data__impl__l2b913($this) {
  return $this;
}
function _UByteArrayInt___get_bytes__impl__pj0ilc($this) {
  return _UByteArrayInt___get_data__impl__l2b913($this);
}
function _UByteArrayInt___init__impl__xif7bu_0(size) {
  return _UByteArrayInt___init__impl__xif7bu(new Int8Array(size));
}
function _UByteArrayInt___init__impl__xif7bu_1(size, gen) {
  var tmp = 0;
  var tmp_0 = new Int8Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = toByte(gen(tmp_1));
    tmp = tmp + 1 | 0;
  }
  return _UByteArrayInt___init__impl__xif7bu(tmp_0);
}
function _UByteArrayInt___get_size__impl__bcjnte($this) {
  return _UByteArrayInt___get_data__impl__l2b913($this).length;
}
function UByteArrayInt__get_impl_px6q8a($this, index) {
  return _UByteArrayInt___get_data__impl__l2b913($this)[index] & 255;
}
function UByteArrayInt__set_impl_gn4532($this, index, value) {
  _UByteArrayInt___get_data__impl__l2b913($this)[index] = toByte(value);
}
function UByteArrayInt__set_impl_gn4532_0($this, index, value) {
  var tmp = _UByteArrayInt___get_data__impl__l2b913($this);
  // Inline function 'kotlin.UByte.toByte' call
  tmp[index] = _UByte___get_data__impl__jof9qr(value);
}
function UByteArrayInt__getOrElse_impl_f0pf72($this, index, default_0) {
  // Inline function 'kotlin.collections.getOrElse' call
  var this_0 = _UByteArrayInt___get_data__impl__l2b913($this);
  var tmp;
  if (0 <= index ? index <= (this_0.length - 1 | 0) : false) {
    tmp = this_0[index];
  } else {
    tmp = toByte(default_0);
  }
  return tmp & 255;
}
function UByteArrayInt__fill_impl_7vnhx3($this, value, fromIndex, toIndex) {
  return fill(_UByteArrayInt___get_data__impl__l2b913($this), toByte(value), fromIndex, toIndex);
}
function UByteArrayInt__fill$default_impl_mdydxi($this, value, fromIndex, toIndex, $super) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _UByteArrayInt___get_size__impl__bcjnte($this) : toIndex;
  var tmp;
  if ($super === VOID) {
    UByteArrayInt__fill_impl_7vnhx3($this, value, fromIndex, toIndex);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new UByteArrayInt(tmp_0)).bb2.call(new UByteArrayInt($this), value, fromIndex, toIndex);
  }
  return tmp;
}
function UByteArrayInt__toString_impl_f8qdsi($this) {
  return 'UByteArrayInt(data=' + toString($this) + ')';
}
function UByteArrayInt__hashCode_impl_y17rdr($this) {
  return hashCode($this);
}
function UByteArrayInt__equals_impl_xlvwxn($this, other) {
  if (!(other instanceof UByteArrayInt))
    return false;
  var tmp0_other_with_cast = other instanceof UByteArrayInt ? other.ab2_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function indexOf(_this__u8e3s4, sub, starting) {
  starting = starting === VOID ? 0 : starting;
  var tmp2 = _this__u8e3s4.length;
  var tmp4 = sub.length;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.memory.array_indexOf' call
    var inductionVariable = starting;
    var last = tmp2 - tmp4 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var eq = 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < tmp4)
          $l$loop: do {
            var m = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(_this__u8e3s4[n + m | 0] === sub[m])) {
              break $l$loop;
            }
            eq = eq + 1 | 0;
          }
           while (inductionVariable_0 < tmp4);
        if (eq === tmp4) {
          tmp$ret$0 = n;
          break $l$block;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = -1;
  }
  return tmp$ret$0;
}
function arraycopy_7(src, srcPos, dst, dstPos, size) {
  return arraycopy_9(_UByteArrayInt___get_data__impl__l2b913(src), srcPos, _UByteArrayInt___get_data__impl__l2b913(dst), dstPos, size);
}
function arraycopy_8(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_9(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function asByteArray(_this__u8e3s4) {
  return _UByteArrayInt___get_data__impl__l2b913(_this__u8e3s4);
}
function arraycopy_10(src, srcPos, dst, dstPos, size) {
  src.db2(srcPos, dst, dstPos, size, true);
}
function arraycopy_11(src, srcPos, dst, dstPos, size) {
  dst.db2(dstPos, src, srcPos, size, false);
}
function _Float32Buffer___init__impl__403k2m(buffer) {
  return buffer;
}
function _Float32Buffer___get_buffer__impl__x5nu9x($this) {
  return $this;
}
function _Float32Buffer___init__impl__403k2m_0(data, offset, size) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? data.length - offset | 0 : size;
  // Inline function 'kotlin.also' call
  var this_0 = Buffer.eb2(imul(size, 4));
  setArray(this_0, 0, data, offset, size);
  return _Float32Buffer___init__impl__403k2m(this_0);
}
function Float32Buffer__get_impl_659lhu($this, index) {
  var tmp0 = _Float32Buffer___get_buffer__impl__x5nu9x($this);
  // Inline function 'korlibs.memory.getF32' call
  var byteOffset = imul(index, 4);
  return true ? tmp0.gb2(byteOffset) : tmp0.fb2(byteOffset);
}
function Float32Buffer__set_impl_34szne($this, index, value) {
  var tmp0 = _Float32Buffer___get_buffer__impl__x5nu9x($this);
  // Inline function 'korlibs.memory.setF32' call
  var byteOffset = imul(index, 4);
  var tmp;
  if (true) {
    tmp0.ib2(byteOffset, value);
    tmp = Unit_instance;
  } else {
    tmp0.hb2(byteOffset, value);
    tmp = Unit_instance;
  }
  return tmp;
}
function Float32Buffer__setArray_impl_eosj51($this, index, inp, offset, size) {
  return setArray(_Float32Buffer___get_buffer__impl__x5nu9x($this), imul(index, 4), inp, offset, size);
}
function _Int8Buffer___init__impl__e20lvc(buffer) {
  return buffer;
}
function _Int8Buffer___get_buffer__impl__q0gulb($this) {
  return $this;
}
function _Int8Buffer___init__impl__e20lvc_0(data, offset, size) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? data.length - offset | 0 : size;
  // Inline function 'kotlin.also' call
  var this_0 = Buffer.eb2(imul(size, 1));
  setArray_0(this_0, 0, data, offset, size);
  return _Int8Buffer___init__impl__e20lvc(this_0);
}
function Int8Buffer__setArray_impl_oimleb($this, index, inp, offset, size) {
  return setArray_0(_Int8Buffer___get_buffer__impl__q0gulb($this), imul(index, 1), inp, offset, size);
}
function _Int32Buffer___init__impl__o98lxn(buffer) {
  return buffer;
}
function _Int32Buffer___get_buffer__impl__dnrimm($this) {
  return $this;
}
function Int32Buffer__setArray_impl_eeeiw8($this, index, inp, offset, size) {
  return setArray_1(_Int32Buffer___get_buffer__impl__dnrimm($this), imul(index, 4), inp, offset, size);
}
function get_size_0(_this__u8e3s4) {
  return _this__u8e3s4.jb2();
}
function sliceWithSize(_this__u8e3s4, start, size) {
  return sliceBuffer(_this__u8e3s4, start, start + size | 0);
}
function clone(_this__u8e3s4, direct) {
  direct = direct === VOID ? false : direct;
  var out = Buffer.eb2(get_size_0(_this__u8e3s4), direct);
  arraycopy_0(_this__u8e3s4, 0, out, 0, get_size_0(_this__u8e3s4));
  return out;
}
function asFloat32(_this__u8e3s4) {
  return _Float32Buffer___init__impl__403k2m(_this__u8e3s4);
}
function copyOf(_this__u8e3s4, newSize) {
  var out = Buffer.eb2(newSize);
  // Inline function 'kotlin.math.min' call
  var a = _this__u8e3s4.jb2();
  var tmp$ret$0 = Math.min(a, newSize);
  arraycopy_0(_this__u8e3s4, 0, out, 0, tmp$ret$0);
  return out;
}
function setArrayLE(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  // Inline function 'korlibs.memory._setArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.kb2(tmp0, data[index]);
    }
     while (inductionVariable < size);
  return Unit_instance;
}
function setInt32(_this__u8e3s4, index, value) {
  return _this__u8e3s4.kb2(imul(index, 4), value);
}
function getInt32(_this__u8e3s4, index) {
  return _this__u8e3s4.lb2(imul(index, 4));
}
function _Uint16Buffer___init__impl__4401ya(buffer) {
  return buffer;
}
function _Uint16Buffer___get_buffer__impl__rei8ax($this) {
  return $this;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function _Uint16Buffer___get_elementSizeInBytes__impl__tcik7m($this) {
  return 2;
}
function Uint16Buffer__get_impl_6qi0dm($this, index) {
  var tmp0 = _Uint16Buffer___get_buffer__impl__rei8ax($this);
  // Inline function 'korlibs.memory.getU16' call
  var byteOffset = imul(index, 2);
  return true ? getU16LE(tmp0, byteOffset) : getU16BE(tmp0, byteOffset);
}
function Uint16Buffer__set_impl_g0kliu($this, index, value) {
  var tmp0 = _Uint16Buffer___get_buffer__impl__rei8ax($this);
  var tmp2 = imul(index, 2);
  // Inline function 'korlibs.memory.set16' call
  var value_0 = toShort(value);
  var tmp;
  if (true) {
    tmp0.ob2(tmp2, value_0);
    tmp = Unit_instance;
  } else {
    tmp0.nb2(tmp2, value_0);
    tmp = Unit_instance;
  }
  return tmp;
}
function Uint16Buffer__setArray_impl_x4uzt($this, index, inp, offset, size) {
  return setArray_2(_Uint16Buffer___get_buffer__impl__rei8ax($this), imul(index, 2), _UShortArrayInt___get_data__impl__l4stnv(inp), offset, size);
}
function Uint16Buffer__toString_impl_rxffha($this) {
  return 'Uint16Buffer(buffer=' + $this.toString() + ')';
}
function Uint16Buffer__hashCode_impl_lcipoz($this) {
  return $this.hashCode();
}
function Uint16Buffer__equals_impl_u4cl2n($this, other) {
  if (!(other instanceof Uint16Buffer))
    return false;
  var tmp0_other_with_cast = other instanceof Uint16Buffer ? other.pb2_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function get_u16(_this__u8e3s4) {
  return asUInt16(_this__u8e3s4);
}
function setFloat32(_this__u8e3s4, index, value) {
  return _this__u8e3s4.ib2(imul(index, 4), value);
}
function get_i32(_this__u8e3s4) {
  return asInt32(_this__u8e3s4);
}
function get_f32(_this__u8e3s4) {
  return asFloat32(_this__u8e3s4);
}
function allocDirect(_this__u8e3s4, size) {
  return Buffer.eb2(size, true);
}
function allocNoDirect(_this__u8e3s4, size) {
  return Buffer.eb2(size, false);
}
function sliceBuffer(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.jb2() : end;
  if (start > end || !(0 <= start ? start <= _this__u8e3s4.jb2() : false) || !(0 <= end ? end <= _this__u8e3s4.jb2() : false)) {
    throw IllegalArgumentException.h2('invalid slice start:' + start + ', end:' + end + ' not in 0..' + _this__u8e3s4.jb2());
  }
  return _this__u8e3s4.rb2(start, end);
}
function getS32Array(_this__u8e3s4, byteOffset, out, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  return littleEndian ? getS32ArrayLE(_this__u8e3s4, byteOffset, out, start, size) : getS32ArrayBE(_this__u8e3s4, byteOffset, out, start, size);
}
function getF32Array(_this__u8e3s4, byteOffset, out, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  return littleEndian ? getF32ArrayLE(_this__u8e3s4, byteOffset, out, start, size) : getF32ArrayBE(_this__u8e3s4, byteOffset, out, start, size);
}
function getS8Array(_this__u8e3s4, byteOffset, out, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  // Inline function 'kotlin.also' call
  arraycopy_10(_this__u8e3s4, byteOffset, out, start, size);
  return out;
}
function get_i8(_this__u8e3s4) {
  return asInt8(_this__u8e3s4);
}
function setUInt8(_this__u8e3s4, index, value) {
  return _this__u8e3s4.sb2(index, toByte(value));
}
function setArray(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE_0(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArray_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  arraycopy_11(data, start, _this__u8e3s4, byteOffset, size);
}
function setArray_1(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE_0(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArray_2(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE_1(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE_1(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function asUInt16(_this__u8e3s4) {
  return _Uint16Buffer___init__impl__4401ya(_this__u8e3s4);
}
function asInt32(_this__u8e3s4) {
  return _Int32Buffer___init__impl__o98lxn(_this__u8e3s4);
}
function getS32ArrayLE(_this__u8e3s4, byteOffset, out, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  // Inline function 'korlibs.memory._getArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = start + n | 0;
      var offset = byteOffset + imul(n, 4) | 0;
      out[tmp0] = _this__u8e3s4.lb2(offset);
    }
     while (inductionVariable < size);
  return out;
}
function getS32ArrayBE(_this__u8e3s4, byteOffset, out, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  // Inline function 'korlibs.memory._getArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = start + n | 0;
      var offset = byteOffset + imul(n, 4) | 0;
      out[tmp0] = _this__u8e3s4.tb2(offset);
    }
     while (inductionVariable < size);
  return out;
}
function getF32ArrayLE(_this__u8e3s4, byteOffset, out, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  // Inline function 'korlibs.memory._getArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = start + n | 0;
      var offset = byteOffset + imul(n, 4) | 0;
      out[tmp0] = _this__u8e3s4.gb2(offset);
    }
     while (inductionVariable < size);
  return out;
}
function getF32ArrayBE(_this__u8e3s4, byteOffset, out, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? out.length - start | 0 : size;
  // Inline function 'korlibs.memory._getArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = start + n | 0;
      var offset = byteOffset + imul(n, 4) | 0;
      out[tmp0] = _this__u8e3s4.fb2(offset);
    }
     while (inductionVariable < size);
  return out;
}
function asInt8(_this__u8e3s4) {
  return _Int8Buffer___init__impl__e20lvc(_this__u8e3s4);
}
function setArrayLE_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  // Inline function 'korlibs.memory._setArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.ib2(tmp0, data[index]);
    }
     while (inductionVariable < size);
  return Unit_instance;
}
function setArrayBE(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  // Inline function 'korlibs.memory._setArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.hb2(tmp0, data[index]);
    }
     while (inductionVariable < size);
  return Unit_instance;
}
function setArrayBE_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  // Inline function 'korlibs.memory._setArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.ub2(tmp0, data[index]);
    }
     while (inductionVariable < size);
  return Unit_instance;
}
function setArrayLE_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  // Inline function 'korlibs.memory._setArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = byteOffset + imul(n, 2) | 0;
      var index = start + n | 0;
      _this__u8e3s4.ob2(tmp0, data[index]);
    }
     while (inductionVariable < size);
  return Unit_instance;
}
function setArrayBE_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  // Inline function 'korlibs.memory._setArray' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = byteOffset + imul(n, 2) | 0;
      var index = start + n | 0;
      _this__u8e3s4.nb2(tmp0, data[index]);
    }
     while (inductionVariable < size);
  return Unit_instance;
}
function getU16LE(_this__u8e3s4, byteOffset) {
  return get_unsigned(_this__u8e3s4.vb2(byteOffset));
}
function getU16BE(_this__u8e3s4, byteOffset) {
  return get_unsigned(_this__u8e3s4.wb2(byteOffset));
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 65535;
}
function checkNBufferSize(size) {
  if (size < 0)
    throw IllegalArgumentException.h2('invalid size ' + size);
  return size;
}
function hashCodeCommon(_this__u8e3s4, buffer) {
  var h = 1;
  var len = buffer.jb2();
  var inductionVariable = 0;
  var last = len / 4 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      h = imul(31, h) + buffer.lb2(imul(n, 4)) | 0;
    }
     while (inductionVariable < last);
  var offset = imul(len / 4 | 0, 4);
  var inductionVariable_0 = 0;
  var last_0 = len % 4 | 0;
  if (inductionVariable_0 < last_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      h = imul(31, h) + buffer.xb2(offset + n_0 | 0) | 0;
    }
     while (inductionVariable_0 < last_0);
  return h;
}
function equalsCommon(_this__u8e3s4, that, other) {
  var tmp;
  if (!(other instanceof Buffer)) {
    tmp = true;
  } else {
    tmp = !(get_size_0(that) === get_size_0(other));
  }
  if (tmp)
    return false;
  return Companion_instance_1.zb1(that, 0, other, 0, that.jb2());
}
function NBuffer_toString(buffer) {
  return 'Buffer(size=' + get_size_0(buffer) + ')';
}
function equalsCommon_0(_this__u8e3s4, src, srcPosBytes, dst, dstPosBytes, sizeInBytes, use64) {
  use64 = use64 === VOID ? true : use64;
  // Inline function 'kotlin.check' call
  if (!((srcPosBytes + sizeInBytes | 0) <= src.jb2())) {
    throw IllegalStateException.o('Check failed.');
  }
  // Inline function 'kotlin.check' call
  if (!((dstPosBytes + sizeInBytes | 0) <= dst.jb2())) {
    throw IllegalStateException.o('Check failed.');
  }
  var offset = 0;
  var remaining = sizeInBytes;
  if (use64) {
    var WORD = 8;
    var words = remaining / WORD | 0;
    remaining = remaining % WORD | 0;
    var inductionVariable = 0;
    if (inductionVariable < words)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v0 = src.yb2((srcPosBytes + offset | 0) + imul(n, WORD) | 0);
        var v1 = dst.yb2((dstPosBytes + offset | 0) + imul(n, WORD) | 0);
        if (!equalsLong(v0, v1)) {
          return false;
        }
      }
       while (inductionVariable < words);
    offset = offset + imul(words, WORD) | 0;
  }
  var WORD_0 = 4;
  var words_0 = remaining / WORD_0 | 0;
  remaining = remaining % WORD_0 | 0;
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < words_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var v0_0 = src.lb2((srcPosBytes + offset | 0) + imul(n_0, WORD_0) | 0);
      var v1_0 = dst.lb2((dstPosBytes + offset | 0) + imul(n_0, WORD_0) | 0);
      if (!(v0_0 === v1_0)) {
        return false;
      }
    }
     while (inductionVariable_0 < words_0);
  offset = offset + imul(words_0, WORD_0) | 0;
  var inductionVariable_1 = 0;
  var last = remaining;
  if (inductionVariable_1 < last)
    do {
      var n_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var v0_1 = src.xb2((srcPosBytes + offset | 0) + n_1 | 0);
      var v1_1 = dst.xb2((dstPosBytes + offset | 0) + n_1 | 0);
      if (!(v0_1 === v1_1)) {
        return false;
      }
    }
     while (inductionVariable_1 < last);
  return true;
}
function getU8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function getS16LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16LE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getS24LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24LE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8 | u8(_this__u8e3s4, offset + 2 | 0) << 16;
  return signExtend(tmp$ret$0, 24);
}
function getU16LE_0(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16LE' call
  return u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8;
}
function getU16BE_0(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16BE' call
  return u8(_this__u8e3s4, offset + 1 | 0) << 0 | u8(_this__u8e3s4, offset + 0 | 0) << 8;
}
function getU24LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24LE' call
  return u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8 | u8(_this__u8e3s4, offset + 2 | 0) << 16;
}
function getU24BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24BE' call
  return u8(_this__u8e3s4, offset + 2 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8 | u8(_this__u8e3s4, offset + 0 | 0) << 16;
}
function getS32LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32LE' call
  return u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8 | u8(_this__u8e3s4, offset + 2 | 0) << 16 | u8(_this__u8e3s4, offset + 3 | 0) << 24;
}
function getS32BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32BE' call
  return u8(_this__u8e3s4, offset + 3 | 0) << 0 | u8(_this__u8e3s4, offset + 2 | 0) << 8 | u8(_this__u8e3s4, offset + 1 | 0) << 16 | u8(_this__u8e3s4, offset + 0 | 0) << 24;
}
function getU16(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getU16LE_0(_this__u8e3s4, offset) : getU16BE_0(_this__u8e3s4, offset);
}
function getS32(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getS32LE(_this__u8e3s4, offset) : getS32BE(_this__u8e3s4, offset);
}
function getS8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset];
}
function getS16BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16BE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 1 | 0) << 0 | u8(_this__u8e3s4, offset + 0 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getU32LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32LE' call
  var tmp$ret$0 = u8(_this__u8e3s4, offset + 0 | 0) << 0 | u8(_this__u8e3s4, offset + 1 | 0) << 8 | u8(_this__u8e3s4, offset + 2 | 0) << 16 | u8(_this__u8e3s4, offset + 3 | 0) << 24;
  return get_unsigned_0(tmp$ret$0);
}
function getS64BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get64BE' call
  // Inline function 'korlibs.memory.get32BE' call
  var offset_0 = offset + 4 | 0;
  var tmp$ret$1 = u8(_this__u8e3s4, offset_0 + 3 | 0) << 0 | u8(_this__u8e3s4, offset_0 + 2 | 0) << 8 | u8(_this__u8e3s4, offset_0 + 1 | 0) << 16 | u8(_this__u8e3s4, offset_0 + 0 | 0) << 24;
  var tmp = shiftLeft(get_unsigned_0(tmp$ret$1), 0);
  // Inline function 'korlibs.memory.get32BE' call
  var offset_1 = offset + 0 | 0;
  var tmp$ret$2 = u8(_this__u8e3s4, offset_1 + 3 | 0) << 0 | u8(_this__u8e3s4, offset_1 + 2 | 0) << 8 | u8(_this__u8e3s4, offset_1 + 1 | 0) << 16 | u8(_this__u8e3s4, offset_1 + 0 | 0) << 24;
  return bitwiseOr(tmp, shiftLeft(get_unsigned_0(tmp$ret$2), 32));
}
function getS8Array_0(_this__u8e3s4, offset, count) {
  return copyOfRange(_this__u8e3s4, offset, offset + count | 0);
}
function getS16ArrayBE(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = new Int16Array(count);
  // Inline function 'kotlin.also' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var pos = offset + imul(n, 2) | 0;
      array[n] = toShort(getS16BE(_this__u8e3s4, pos));
    }
     while (inductionVariable < count);
  return array;
}
function getU16ArrayBE(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = charArray(count);
  // Inline function 'kotlin.also' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var pos = offset + imul(n, 2) | 0;
      array[n] = numberToChar(getS16BE(_this__u8e3s4, pos));
    }
     while (inductionVariable < count);
  return array;
}
function getS32ArrayLE_0(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = new Int32Array(count);
  // Inline function 'kotlin.also' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var pos = offset + imul(n, 4) | 0;
      array[n] = getS32LE(_this__u8e3s4, pos);
    }
     while (inductionVariable < count);
  return array;
}
function getS32ArrayBE_0(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = new Int32Array(count);
  // Inline function 'kotlin.also' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var pos = offset + imul(n, 4) | 0;
      array[n] = getS32BE(_this__u8e3s4, pos);
    }
     while (inductionVariable < count);
  return array;
}
function get_unsigned_0(_this__u8e3s4) {
  return bitwiseAnd(fromInt(_this__u8e3s4), new Long(-1, 0));
}
function u8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function ensureWrite($this, count) {
  if (count <= $this.jb3_1.fb3_1)
    return Unit_instance;
  if (!$this.ib3_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.jb3_1.fb3_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.o(toString(message));
  }
  var minNewSize = $this.jb3_1.gb3_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new SimpleRingBuffer(ilog2(minNewSize) + 2 | 0);
  this_0.nb3($this.jb3_1);
  tmp.jb3_1 = this_0;
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function writeFullNoCopy($this, data) {
  // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
  $this.pb3_1.d2(data);
  $this.rb3_1 = $this.rb3_1 + data.length | 0;
}
function consumeChunkSize($this, $receiver, size) {
  var chunk = $receiver;
  // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
  $this.qb3_1 = $this.qb3_1 + size | 0;
  $this.rb3_1 = $this.rb3_1 - size | 0;
  if ($this.qb3_1 >= chunk.length) {
    $this.pb3_1.zl();
    $this.qb3_1 = 0;
  }
}
function signExtend(_this__u8e3s4, bits) {
  return _this__u8e3s4 << (32 - bits | 0) >> (32 - bits | 0);
}
function _ByteUnits___init__impl__x795am(bytes) {
  return bytes;
}
function _ByteUnits___get_bytes__impl__leukoc($this) {
  return $this;
}
function _ByteUnits___get_bytesLong__impl__1lc1w0($this) {
  return numberToLong(_ByteUnits___get_bytes__impl__leukoc($this));
}
function _ByteUnits___get_kiloBytes__impl__jnym6r($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / 1024.0;
}
function _ByteUnits___get_megaBytes__impl__qjjio2($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / (1024.0 * 1024.0);
}
function _ByteUnits___get_gigaBytes__impl__i7s8s8($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / (1024.0 * 1024.0 * 1024.0);
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function roundToDigits($this, $receiver, digits) {
  // Inline function 'kotlin.math.pow' call
  var num = Math.pow(10.0, digits);
  return roundToInt($receiver * num) / num;
}
function ByteUnits__toString_impl_ox2ku2($this) {
  return _ByteUnits___get_gigaBytes__impl__i7s8s8($this) >= 1.0 ? '' + roundToDigits($this, _ByteUnits___get_gigaBytes__impl__i7s8s8($this), 1) + ' GB' : _ByteUnits___get_megaBytes__impl__qjjio2($this) >= 1.0 ? '' + roundToDigits($this, _ByteUnits___get_megaBytes__impl__qjjio2($this), 1) + ' MB' : _ByteUnits___get_kiloBytes__impl__jnym6r($this) >= 1.0 ? '' + roundToDigits($this, _ByteUnits___get_kiloBytes__impl__jnym6r($this), 1) + ' KB' : _ByteUnits___get_bytesLong__impl__1lc1w0($this).toString() + ' B';
}
function get_isLittleEndian() {
  _init_properties_Buffer_js_kt__30np2z();
  return isLittleEndian;
}
var isLittleEndian;
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function get_arrayUByte(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Uint8Array(get_buffer(_this__u8e3s4), _this__u8e3s4.xb3(), _this__u8e3s4.jb2());
}
function get_arrayInt(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int32Array(get_buffer(_this__u8e3s4), _this__u8e3s4.xb3(), _this__u8e3s4.jb2() / 4 | 0);
}
function get_arrayFloat(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Float32Array(get_buffer(_this__u8e3s4), _this__u8e3s4.xb3(), _this__u8e3s4.jb2() / 4 | 0);
}
function asInt32Array(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int32Array(_this__u8e3s4);
}
function asInt8Array(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int8Array(_this__u8e3s4);
}
function get_buffer(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return _this__u8e3s4.cb2_1.buffer;
}
var properties_initialized_Buffer_js_kt_i0s0qv;
function _init_properties_Buffer_js_kt__30np2z() {
  if (!properties_initialized_Buffer_js_kt_i0s0qv) {
    properties_initialized_Buffer_js_kt_i0s0qv = true;
    // Inline function 'kotlin.also' call
    var this_0 = new Uint32Array(1);
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0[0] = 287454020;
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array(this_0.buffer))[0] === 68;
  }
}
//region block: post-declaration
initMetadataForClass(UByteArrayInt, 'UByteArrayInt');
initMetadataForCompanion(Companion);
initMetadataForInterface(TypedBuffer, 'TypedBuffer');
protoOf(Uint16Buffer).s2 = get_size;
initMetadataForClass(Uint16Buffer, 'Uint16Buffer', VOID, VOID, [TypedBuffer]);
initMetadataForClass(SimpleBytesDeque, 'SimpleBytesDeque', SimpleBytesDeque);
initMetadataForClass(SimpleChunkedByteDeque, 'SimpleChunkedByteDeque', SimpleChunkedByteDeque);
initMetadataForClass(SimpleRingBuffer, 'SimpleRingBuffer');
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Buffer, 'Buffer', VOID, VOID, [AutoCloseable]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  UByteArrayInt__fill$default_impl_mdydxi as UByteArrayInt__fill$default_impl_mdydxi3r6vmt78bnj2k,
  ByteUnits__toString_impl_ox2ku2 as ByteUnits__toString_impl_ox2ku214nbr4e7vbgkn,
  _Float32Buffer___init__impl__403k2m_0 as _Float32Buffer___init__impl__403k2m26kpmn3jn9766,
  _Float32Buffer___get_buffer__impl__x5nu9x as _Float32Buffer___get_buffer__impl__x5nu9x318r0i4ytjupn,
  Float32Buffer__get_impl_659lhu as Float32Buffer__get_impl_659lhu1x3dejetpls19,
  Float32Buffer__set_impl_34szne as Float32Buffer__set_impl_34szne3r2rr4ely4rlt,
  _Int8Buffer___init__impl__e20lvc_0 as _Int8Buffer___init__impl__e20lvc1uxb02cec5h7,
  _Int8Buffer___get_buffer__impl__q0gulb as _Int8Buffer___get_buffer__impl__q0gulb212vj8jj34yk6,
  _UByteArrayInt___init__impl__xif7bu as _UByteArrayInt___init__impl__xif7bu20fs1loq9z3ij,
  _UByteArrayInt___init__impl__xif7bu_0 as _UByteArrayInt___init__impl__xif7bu22xrgtz1pdtsf,
  _UByteArrayInt___init__impl__xif7bu_1 as _UByteArrayInt___init__impl__xif7bu1o76z3u88qyf8,
  _UByteArrayInt___get_bytes__impl__pj0ilc as _UByteArrayInt___get_bytes__impl__pj0ilcf0l2x8xq7gcj,
  UByteArrayInt__getOrElse_impl_f0pf72 as UByteArrayInt__getOrElse_impl_f0pf72aegw9voo79ft,
  UByteArrayInt__get_impl_px6q8a as UByteArrayInt__get_impl_px6q8a35txexjj6o4n0,
  UByteArrayInt__set_impl_gn4532 as UByteArrayInt__set_impl_gn453221vabkkeeuf12,
  UByteArrayInt__set_impl_gn4532_0 as UByteArrayInt__set_impl_gn453226wrap3736y9v,
  _UByteArrayInt___get_size__impl__bcjnte as _UByteArrayInt___get_size__impl__bcjnte1ffm0g6so1ivs,
  _UShortArrayInt___init__impl__kdofb8_0 as _UShortArrayInt___init__impl__kdofb815k0nr37fhkly,
  UShortArrayInt__get_impl_ciz20k as UShortArrayInt__get_impl_ciz20k2vat303djh1bv,
  UShortArrayInt__set_impl_38wgvc as UShortArrayInt__set_impl_38wgvc1v2d04p43ifye,
  Uint16Buffer__set_impl_g0kliu as Uint16Buffer__set_impl_g0kliulc5gukztwaxh,
  Companion_getInstance_0 as Companion_getInstance2birn9imkruen,
  Companion_instance_1 as Companion_instance3nd7lb5y5x9nc,
  Buffer as Buffer25z94vsj0kb1s,
  SimpleBytesDeque as SimpleBytesDeque3uob1f4dosqej,
  SimpleChunkedByteDeque as SimpleChunkedByteDeque3cr64mogfywgm,
  SimpleRingBuffer as SimpleRingBuffer1a4k3g2va6i8y,
  UByteArrayInt as UByteArrayInt247ue4nx0pkns,
  allocDirect as allocDirecttfrgytwudkpf,
  allocNoDirect as allocNoDirect3dykranmovqsj,
  get_arrayFloat as get_arrayFloat1r0vk858s9phl,
  get_arrayInt as get_arrayInt3v8kuk47rixtz,
  get_arrayUByte as get_arrayUByte9swx7ogt2hf2,
  arrayadd as arrayadd3erpr00t9k8j,
  arraycopy_9 as arraycopy3czrd9re36wzt,
  arraycopy_8 as arraycopy14jict0dth60o,
  arraycopy as arraycopy52dxe7vhzf14,
  arraycopy_4 as arraycopyphzg5lpa6gvz,
  arraycopy_3 as arraycopyqmyo4vjwforw,
  arraycopy_6 as arraycopy1hsh296f5d0xg,
  arraycopy_7 as arraycopy3n78tfzvkl4kg,
  arraycopy_5 as arraycopy3fi6tr79d693r,
  arraycopy_0 as arraycopy3uxsqjlixmnz3,
  arraycopy_2 as arraycopy28e1us87mwypg,
  arraycopy_1 as arraycopy9a0yzbjqwnvw,
  arrayequal as arrayequal25g4om83vd8w1,
  arrayfill_0 as arrayfill1njpugsfcm512,
  arrayfill as arrayfill2iqmyqqqfwuaf,
  asByteArray as asByteArray1mw554k0vpuh5,
  asInt32Array as asInt32Arrayf0ml2lp92o3m,
  asInt8Array as asInt8Array769i4qnpoc13,
  asUShortArrayInt as asUShortArrayInt2gfk0h9rafip5,
  clone as clonelcrqoxe4ne5i,
  copyOf as copyOfnqvdm0sc8lk,
  get_f32 as get_f3218rglfhpgbhzp,
  getF32Array as getF32Array3bpq574bgh35w,
  getInt32 as getInt32gmg3zyw00v1v,
  getS16ArrayBE as getS16ArrayBE3bj6gsad0tz3k,
  getS16BE as getS16BE6c2odqehs5au,
  getS16LE as getS16LE39jsuv9u9gi4y,
  getS24LE as getS24LE1b229asvs5i3l,
  getS32ArrayBE_0 as getS32ArrayBE30ehj217529qp,
  getS32ArrayLE_0 as getS32ArrayLE2u84ix7qnexrb,
  getS32Array as getS32Array38egwts6rsd12,
  getS32BE as getS32BE5aphh7sm8f2q,
  getS32LE as getS32LE1pxm9wohin3g8,
  getS32 as getS3225c4j90s7n16a,
  getS64BE as getS64BE1b3e93qe1xjxx,
  getS8Array as getS8Array37elyr0qhrpi8,
  getS8Array_0 as getS8Array1clq6jd2z5jh9,
  getS8 as getS83kqgdtkseh4fp,
  getU16ArrayBE as getU16ArrayBE1cpolqhg4wxps,
  getU16BE_0 as getU16BE2rszf3doox5o,
  getU16LE_0 as getU16LE2cizldw8qp53x,
  getU16 as getU1616fejrhhqwfv2,
  getU24BE as getU24BE36pml41y2814b,
  getU24LE as getU24LEi3x1z5ajbdbv,
  getU32LE as getU32LE1yo0ft9yyv0wa,
  getU8 as getU83agrw8yj0shar,
  get_i32 as get_i323p4hlz6j3xys8,
  get_i8 as get_i83qhdj74rhdyeg,
  indexOf as indexOf1wbggs5i7ilsw,
  setArrayLE as setArrayLEwil75hzlfusu,
  setFloat32 as setFloat323e0ukqyly1ufv,
  setInt32 as setInt32178h074gei71f,
  get_size_0 as get_size13scmefs6mbfn,
  sliceBuffer as sliceBufferpiate0wictoq,
  sliceWithSize as sliceWithSize2i7i6olf26byj,
  get_u16 as get_u163bxpdbbave1v5,
};
//endregion
